import { render, staticRenderFns } from "./invoice-infomanage-detail.vue?vue&type=template&id=324be2b8&scoped=true&"
import script from "./invoice-infomanage-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-infomanage-detail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-infomanage-detail.vue?vue&type=style&index=0&id=324be2b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324be2b8",
  null
  
)

export default component.exports